module.exports = __webpack_public_path__ + "static/media/zipper.b711087d.mp3";